
import { Collapse, Button } from "antd";
import UserOutlined from "@ant-design/icons/lib/icons/UserOutlined";
import CircularProgress from "../CircularProgress";
import Classes from "./index.module.css";
const Panel = Collapse.Panel;
export default function AccountBalanceItem({
  name,
  id,
  address,
  tel,
  phone,
  cashBalance,
  chequeBalance,
  maxOpeninvoices,
  maxDaysForCheque,
  cashAccountBalance,
  status,
  invoiceCount,
  chequeAccountBalance,
  open = true,
  btn,
  loading=false,
}) {
  const isOpen = open ? { defaultActiveKey: [1] } : null;
  return (
    <>
      <Collapse className={Classes.CustomerGridItem} {...isOpen}>
        <Panel
          className={status ? Classes.indebted : Classes.creditor}
          showArrow={false}
          header={[<UserOutlined />, name, "-", id]}
          key={1}
        >
          {!loading && <button onClick={btn} className={Classes.btn}>
            <span>{address}</span>
            <table>
              <tbody>
                <tr>
                  <td colSpan={2}>تلفن : </td>
                  <td>{tel ? tel : "-"}</td>
                </tr>
                <tr>
                  <td colSpan={2}>تلفن همراه : </td>
                  <td>{phone ? phone : "-"}</td>
                </tr>
                <tr>
                  <td colSpan={2}>اعتبار ریالی : </td>
                  <td>{cashBalance ? cashBalance : 0}</td>
                </tr>
                <tr>
                  <td colSpan={2}>اعتبار چکی : </td>
                  <td>{chequeBalance ? chequeBalance : 0}</td>
                </tr>
                <tr>
                  <td colSpan={2}>حداکثر فاکتور باز : </td>
                  <td>{maxOpeninvoices ? maxOpeninvoices : 0}</td>
                </tr>
                <tr>
                  <td colSpan={2}>حداکثر مدت چک : </td>
                  <td>{maxDaysForCheque ? maxDaysForCheque : 0}</td>
                </tr>
                <tr className={status ? Classes.indebted : Classes.creditor}>
                  <td colSpan={2}>مانده حساب : </td>
                  <td>
                    {cashAccountBalance}
                    {status ? <small>بدهکار</small> : <small>بستانکار</small>}(
                    {invoiceCount}فاکتور)
                  </td>
                </tr>
                <tr>
                  <td colSpan={2}>مانده چک : </td>
                  <td>{chequeAccountBalance ? chequeAccountBalance : 0}</td>
                </tr>
              </tbody>
            </table>
          </button>}
          {loading && <CircularProgress/>}
        </Panel>
      </Collapse>
    </>
  );
}